import React, { useMemo } from 'react';

import Typography from 'components-new/typography/typography';

import AsyncSelectTags from 'components-new/async-select-tags/async-select-tags';

import { createLocale } from 'locales';

import { useOrganizationWeekPlanner } from 'state/context/organization/OrganizationWeekPlanner';
import useUserFreelancersAutoComplete from 'state/remote/remote-organization/use-user-freelancers-auto-complete';
import useUsersDetails from 'state/remote/remote-organization/use-users-details';

const localize = createLocale('organizationWeekPlannerLocales');

const FreelancersFilter: React.FC = () => {
  const { organizationPlannerSearchParams } = useOrganizationWeekPlanner();
  const {
    selectedFreelancers,
    onSelectedFreelancersChange,
    onFreelancersQueryChange,
    freelancersQuery,
  } = organizationPlannerSearchParams;
  const { data, isLoading } = useUserFreelancersAutoComplete(
    freelancersQuery ? { query: freelancersQuery } : {},
  );

  const usersDetailsResponse = useUsersDetails(selectedFreelancers);

  const currentSelectedFreelancers = useMemo(() => {
    return usersDetailsResponse.data.map((user) => ({
      id: user.user_id,
      value: user.name,
    }));
  }, [usersDetailsResponse.data]);

  return (
    <div className="mt-4">
      <Typography className="text-gray300" variant="heading-4" as="span">
        {localize('selectFreelancer')}
      </Typography>

      <AsyncSelectTags
        className="mt-1"
        onSelectedValueChange={onSelectedFreelancersChange}
        options={data.map((item) => ({
          active: selectedFreelancers.includes(item.value as unknown as number),
          id: item.value,
          value: item.text,
        }))}
        placeholder={localize('searchFreelancer')}
        onQueryChange={onFreelancersQueryChange}
        loading={isLoading}
        query={freelancersQuery}
        defaultSelectedValues={currentSelectedFreelancers}
      />
    </div>
  );
};

export default FreelancersFilter;
